module.exports = __webpack_public_path__ + "img/83.5.COD.358f35f2.png";